import { useCallback, useMemo, useState } from 'react';

import { Control, UseFormGetValues, UseFormReset } from 'react-hook-form';

import { ProductsFiltersForm } from 'app/api/products';
import { useModal } from 'hooks';
import { useOrganicFilter } from '../../../../OrganicFilter/hooks';

interface UseOrganicSeedFilterProps {
  control: Control<ProductsFiltersForm>;
  controlName: string;
  getValues: UseFormGetValues<ProductsFiltersForm>;
  reset: UseFormReset<ProductsFiltersForm>;
}

export const useOrganicSeedFilter = ({ control, controlName, getValues, reset }: UseOrganicSeedFilterProps) => {
  const { open, handleCloseModal, handleOpenModal } = useModal();
  const [previousValues, setPreviousValues] = useState<ProductsFiltersForm | null>(null);

  const { currentValue, filterTitle, isSelected } = useOrganicFilter(control as unknown as Control, controlName);

  const isFilterChanged = useMemo(
    () => previousValues?.organic !== currentValue,
    [currentValue, previousValues?.organic],
  );

  const handleOpen = useCallback(() => {
    setPreviousValues(getValues());
    reset();
    handleOpenModal();
  }, [getValues, handleOpenModal, reset]);

  const handleResetSelected = useCallback(() => {
    if (previousValues) {
      reset(previousValues);
    }
  }, [previousValues, reset]);

  const handleClose = useCallback(() => {
    handleResetSelected();
    handleCloseModal();
  }, [handleCloseModal, handleResetSelected]);

  const handleConfirm = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  return {
    counter: isSelected ? 1 : 0,
    isFilterChanged,
    filterTitle,
    open,
    handleCloseModal: handleClose,
    handleOpenModal: handleOpen,
    handleConfirm,
  };
};
